// AUTO-GENERATED from docs/schema.md by scripts/generate-schema-content.mjs.
// Do not edit by hand. Run `yarn gen:schema` (or any app build) to regenerate.
/* eslint-disable */
export const schemaMarkdown = `# Component catalog field reference (YAML)

This document describes the fields you can use in \`catalog-info.yaml\` (at your repository root) for **Component** entities. It reflects the catalog schema defined in the [Heroku Catalog Field Definitions for Backstage RFC](https://github.com/heroku/rfcs/blob/main/approved/000318-Heroku%20Catalog%20Field%20Definitions%20for%20Backstage.md).

## Minimum required example

\`\`\`yaml
apiVersion: backstage.io/v1alpha1
kind: Component
metadata:
  name: my-new-components
spec:
  type: service
  lifecycle: production
  owner: group:default/my-team
\`\`\`

The generated field tables below and runtime catalog validation share the machine-readable [\`component.schema.json\`](https://github.com/heroku/heroku-backstage/blob/main/plugins/backstage-plugin-catalog-backend-module-heroku/src/component.schema.json) source. Update that schema and run \`yarn gen:schema\`; do not edit generated table sections directly.

> **Before you start.** Heroku keys in \`catalog-info.yaml\` use **kebab-case** and their values are **lowercase** — booleans are lowercase quoted strings (\`'true'\` / \`'false'\`) and enums are lowercase slugs (\`platform\`, \`both\`). Omit optional fields that don't apply rather than writing placeholders like \`TBD\` or \`N/A\`: absence is the signal, and Backstage fills the documented default at ingestion (see the "defaults to … when unset" notes below), so an omitted field still lands in a consistent, filterable bucket.

The tables below are grouped by where the field lives in the YAML. The **Required** column marks fields every Component must set; everything else is optional.

---

## Top-level fields

<!-- BEGIN GENERATED:top-level -->
| Field | Required | Meaning | Allowed values |
| --- | --- | --- | --- |
| \`apiVersion\` | yes | Backstage API version | \`backstage.io/v1alpha1\` |
| \`kind\` | yes | Entity kind | \`Component\` |
<!-- END GENERATED:top-level -->

---

## metadata

<!-- BEGIN GENERATED:metadata -->
| Field | Required | Meaning | Notes |
| --- | --- | --- | --- |
| \`metadata.name\` | yes | Unique identifier (slug) | Lowercase, dash-separated only: \`^[a-z0-9-]+$\` |
| \`metadata.title\` |  | Human-readable display name | Can include spaces and capitals. \`metadata.name\` remains the identifier. |
| \`metadata.description\` |  | Short description | Sourced from the GitHub repo description by default; set here to override. |
<!-- END GENERATED:metadata -->

---

## metadata.annotations (optional)

Informational metadata; not indexed or used for filtering.

<!-- BEGIN GENERATED:annotations -->
| Annotation | Meaning | Format / values |
| --- | --- | --- |
| \`backstage.io/source-location\` | Source code location | \`url:\` followed by an HTTPS URL to your Git source, for example \`url:https://github.com/org/repo\` or \`url:https://some.url.com/my-enterprise-git/my-org/my-repo\` |
| \`github.com/project-slug\` | GitHub repo identifier | \`org/repo\` |
| \`backstage.io/code-coverage\` | Enables the Code Coverage tab | \`enabled\` (coverage data is uploaded from CI, not stored here). See [Code Coverage in Backstage](https://github.com/heroku/heroku-backstage/blob/main/docs/code-coverage.md). |
| \`pagerduty.com/service-id\` | PagerDuty service ID | For on-call integration |
| \`heroku.com/pipeline-uuid\` | Heroku pipeline UUID | UUID from the Heroku Dashboard |
| \`heroku.com/legacy-components-id\` | ID in the Components-compatible API | Use when this Component already has an ID in the Components service. |
| \`heroku.com/github-actions-ci-workflow\` | CI workflow that must pass | Workflow name (e.g. \`test\`). When unset, all workflows are required to pass. |
<!-- END GENERATED:annotations -->

---

## metadata.labels

Used for filtering and grouping in the Backstage UI. Values may only contain \`[a-zA-Z0-9._-]\` — no spaces (e.g. \`dogwood-kernel\`, not \`Dogwood Kernel\`).

<!-- BEGIN GENERATED:labels -->
| Label | Required | Meaning | Allowed values |
| --- | --- | --- | --- |
| \`heroku.com/stack\` |  | Runtime stack | \`platform\`, \`kernel\`, \`dogwood-kernel\`, \`fir-kernel\`, \`ec2-non-kernel\`, \`infrastructure\`, \`other\`, \`none\` (no stack). Defaults to \`none\` when unset. |
| \`heroku.com/github-actions\` |  | Uses GitHub Actions | \`'true'\`, \`'false'\`. Defaults to \`'false'\` when unset. |
| \`heroku.com/github-release\` |  | Uses GitHub Releases | \`'true'\`, \`'false'\`. Defaults to \`'false'\` when unset. |
| \`heroku.com/heroku-ci\` |  | Uses Heroku CI | \`'true'\`, \`'false'\`. Defaults to \`'false'\` when unset. |
| \`heroku.com/component-tier\` |  | Criticality tier | \`'0'\` (critical platform), \`'1'\` (critical feature), \`'2'\` (important), \`'3'\` (internal), \`'4'\` (ancillary), \`none\` (not a service). **Omit for non-services** (e.g. NPM packages, buildpacks); defaults to \`none\` when unset. |
| \`heroku.com/pci-tier\` |  | PCI compliance tier | \`'1'\`, \`'1a'\`, \`'1b'\`, \`'2'\`, \`'2a'\`, \`'2b'\`, \`'2c'\`, \`'2x'\`, \`'3'\`, \`none\`. **Omit when not PCI-scoped**; defaults to \`none\` when unset. |
| \`heroku.com/consumer-type\` |  | How the component is consumed | \`api\`, \`browser\`, \`both\`, \`none\`. **Omit if the component has no consumer type** (e.g. a buildpack); defaults to \`none\` when unset. |
| \`heroku.com/sox\` |  | SOX compliance | \`'true'\`, \`'false'\`. Defaults to \`'false'\` when unset. |
| \`heroku.com/soc2\` |  | SOC2 compliance | \`'true'\`, \`'false'\`. Defaults to \`'false'\` when unset. |
| \`heroku.com/data-maintenance-pg\` |  | PostgreSQL maintenance mode | \`manual\`, \`scheduled\`. Set **only if** the component owns a PG addon. Defaults to \`scheduled\` when unset. |
| \`heroku.com/data-maintenance-kvs\` |  | KVS maintenance mode | \`manual\`, \`scheduled\`. Set **only if** the component owns a KVS addon. Defaults to \`scheduled\` when unset. |
<!-- END GENERATED:labels -->

---

## metadata.links (optional)

Array of \`{ title, url }\` (optional \`icon\`). Example: Documentation, Metrics, Runbook.

---

## spec

<!-- BEGIN GENERATED:spec -->
| Field | Required | Meaning | Format / values |
| --- | --- | --- | --- |
| \`spec.type\` | yes | Component type | \`service\` (backend/API), \`website\` (user-facing web property that is not an API), \`library\` (reusable code, buildpack, package, or binary) |
| \`spec.lifecycle\` | yes | Lifecycle stage | \`non-production\`, \`production\`, \`deprecated\`, \`sunset\` (see below) |
| \`spec.owner\` | yes | Owning team | \`group:default/<team-slug>\` — must reference a valid Group entity |
| \`spec.system\` |  | System this component belongs to | \`<system-name>\`; references a System entity. Nice to have where a suitable System exists — systems are not yet fully defined. |
| \`spec.dependsOn\` |  | Components or resources this depends on | Array of \`component:default/<name>\` or \`resource:default/<name>\`. Nice to have where the dependencies are known. |
| \`spec.providesApis\` |  | APIs this component provides | Array of \`api:default/<name>\` |
| \`spec.consumesApis\` |  | APIs this component consumes | Array of \`api:default/<name>\` |
| \`spec.subcomponentOf\` |  | Parent component | \`component:default/<name>\` |
<!-- END GENERATED:spec -->

**\`spec.lifecycle\` values:**

<!-- BEGIN GENERATED:lifecycle -->
| Value | Meaning |
| --- | --- |
| \`non-production\` | Prototypes, dev-only, experimental, proof-of-concept. Not intended for production traffic. |
| \`production\` | Stable and production-ready; actively maintained. |
| \`deprecated\` | Still running in production, but discouraged for new work. |
| \`sunset\` | Fully off — no dynos running, repo archived, no maintenance obligation. |
<!-- END GENERATED:lifecycle -->

---

## Heroku app example

A typical Heroku service connected to GitHub and a pipeline might look like this:

\`\`\`yaml
apiVersion: backstage.io/v1alpha1
kind: Component
metadata:
  name: checkout-service
  title: Checkout Service
  description: Processes customer checkouts
  annotations:
    github.com/project-slug: heroku/checkout-service
    heroku.com/pipeline-uuid: 550e8400-e29b-41d4-a716-446655440000
  labels:
    heroku.com/stack: platform
    heroku.com/component-tier: '1'
    heroku.com/consumer-type: api
    heroku.com/github-actions: 'true'
  links:
    - title: Documentation
      url: https://docs.example.com/checkout-service
spec:
  type: service
  lifecycle: production
  owner: group:default/checkout
\`\`\`

---

## Other entity kinds

This reference covers **Component** entities. The catalog also uses **User** and **Group** entities for ownership, and supports **System**, **Domain**, **API**, and **Resource** entities. See the [RFC](https://github.com/heroku/rfcs/blob/main/approved/000318-Heroku%20Catalog%20Field%20Definitions%20for%20Backstage.md) for their schemas.

Organization info (users, teams, systems, domains) plus public and 3rd-party component stubs are stored centrally in **[github.com/heroku/backstage-entities](https://github.com/heroku/backstage-entities)**, not in individual component repos. The \`spec.owner\` of a component references a \`Group\` defined there.

**Group** annotations live under the \`sfdc.co/\` namespace:

| Annotation | Meaning |
|------------|---------|
| \`sfdc.co/gus-team-id\` | GUS team ID (the link is generated from the ID) |
| \`sfdc.co/gus-intake-product-tag-id\` | GUS intake product tag ID |

**Legacy Components identifier:** \`heroku.com/legacy-components-id\` holds the entity's ID in the legacy Components service; the Teams/Components API uses it to resolve teams and components. Applies to both \`Group\` (team) entities and \`Component\` entities.

---

> JSON source translation and Components-compatible API behavior are documented in the [Catalog compatibility surface](https://github.com/heroku/heroku-backstage/blob/main/docs/catalog-compatibility.md).
`;
